export default __webpack_public_path__ + "img/9f276a2d17e36e964664b4440d1b8f3c.svg";